const labelsIT = {
    "view": {
        "table": {
            "title": "La tua lista di etichette",
            "column": {
                "name": "Nome",
                "owner": "Proprietario",
                "company": "Azienda",
                "contract": "Contratto",
                "info": "Informazioni",
                "status": "Stato",
                "action": "Azione"
            },
            "button": {
                "edit": "Modifica",
                "export_csv": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "label": {
                "approved": "Approvato",
                "waiting_approval": "In attesa di approvazione"
            }
        },
        "message": {
            "success": "L'etichetta è stata rimossa!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!",
            "notSubscribed": "Non sei iscritto a nessun piano, quindi puoi aggiungere solo <strong>3 etichette</strong>. Per favore <3>iscriviti</3> a un piano per avere un numero illimitato di etichette.",
            "subscriptionUpgrade": "Il tuo attuale piano di abbonamento non supporta questa funzione. Si prega di <1>aggiornare</1> il piano di abbonamento per usufruire di questa funzione.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Si prega di <1>riprendere</1> l'abbonamento per usufruire di questa funzione.",
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni."
        },
        "modal": {
            "delete": {
                "header": "Eliminare l'etichetta {{labelName}}?",
                "body": "Sei sicuro di voler eliminare l'etichetta {{labelName}}? Questa azione non può essere annullata."
            }
        }
    },
    "add": {
        "title": "Aggiungi Etichetta",
        "form": {
            "label": {
                "required": "Richiesto",
                "name": "Nome",
                "subuser": "Sotto-utente",
                "logo": "Logo",
                "promo_graphic": "Grafica Promozionale",
                "primary_genre": "Genere primario",
                "secondary_genre": "Genere secondario",
                "year_established": "Anno di fondazione",
                "releases_in_catalog": "Pubblicazioni nel catalogo",
                "soundcloud": "Soundcloud",
                "website": "Sito web",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "subuser": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un'etichetta per uno dei tuoi sotto-utenti, altrimenti lascia non selezionato.",
                "logo": "Carica formati JPG o PNG, risoluzione solo 1000x1000 px",
                "promo_graphic": "Carica formati JPG o PNG, risoluzione solo 960x150px, max 100kb"
            },
            "placeholder": {
                "subuser": "Seleziona Sotto-utente..."
            },
            "button": {
                "reset": "Resetta",
                "submit": "Invia"
            },
            "message": {
                "success": "L'etichetta è stata aggiunta!",
                "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
            }
        },
        "modal": {
            "addLabel": {
                "header": "Aggiungere l'etichetta {{labelName}}?",
                "body": "Sei sicuro di voler creare una nuova etichetta? Assicurati di inserire un nome di etichetta unico. Per esserne sicuro, controlla se il nome esiste già in negozi come Beatport e Traxsource. Ogni invio deve essere approvato e registrato dal team di Music Link. Solitamente approviamo e registriamo nuove etichette entro 48 ore.",
                "button": {
                    "confirm": "Conferma",
                    "cancel": "Annulla"
                }
            }
        },
        "message": {
            "success": "L'etichetta è stata aggiunta!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
        }
    },
    "update": {
        "title": "Modifica Etichetta",
        "form": {
            "label": {
                "required": "Richiesto",
                "name": "Nome",
                "logo": "Logo",
                "promo_graphic": "Grafica Promozionale",
                "primary_genre": "Genere primario",
                "secondary_genre": "Genere secondario",
                "year_established": "Anno di fondazione",
                "releases_in_catalog": "Pubblicazioni nel catalogo",
                "soundcloud": "Soundcloud",
                "website": "Sito web",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "logo": "Carica formati JPG o PNG, risoluzione solo 1000x1000 px",
                "promo_graphic": "Carica formati JPG o PNG, risoluzione solo 960x150px, max 100kb"
            },
            "placeholder": {},
            "button": {
                "submit": "Invia"
            },
            "message": {
                "success": "L'etichetta è stata aggiornata!",
                "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
            }
        }
    }
};

export default labelsIT;